import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

import { mapListEnvelope, mapOrderListItem } from '../_transform';

function getUrl() {
  return 'v4/stock-trading/public/order/MARGIN/list';
}

/**
 * @typedef   {object}    MtOrderListParams
 * @property  {string}    tickerCode
 * @property  {string}    transactionType
 * @property  {string?}   periodType
 * @property  {string?}   statusType
 * @property  {string?}   upDownPrice
 * @property  {number?}   pageSize
 */

/**
 * @typedef {'day'|'session'}  OrderPeriod
 */

/**
 * Docs?:
 * TODO: Search Docs
 *
 * @typedef   {object}  OrderMt
 *
 * @property  {string}      order_no              (Ex: '20014')
 * @property  {string}      idx_order_no          (Ex: '202305300000000016')
 * @property  {string}      transaction_type      (Ex: '1') -> 1 = Buy
 * @property  {string}      stock                 (Ex: 'BBRI')
 * @property  {string}      market_type           (Ex: '0RG')
 * @property  {number}      price_order           (Ex: 5775)
 * @property  {number}      lot_input             (Ex: 1)
 * @property  {number}      open_order            (Ex: 0)
 * @property  {number}      done_order            (Ex: 1)
 * @property  {number}      shares_input          (Ex: 100)
 * @property  {number}      openshares_order      (Ex: 100)
 * @property  {number}      doneshares_order      (Ex: 0)
 * @property  {string}      order_time            (Ex: '2023-05-30T15:58:39.000000')
 * @property  {string}      executed_time         (Ex: '18:46:05')
 * @property  {string}      message               (Ex: '-')
 * @property  {string}      status                (Ex: '0')
 * @property  {string}      status_description    (Ex: 'Open')
 * @property  {number}      total_price           (Ex: 577500)
 * @property  {number?}     lowvolamend           (Ex: 577500)
 * @property  {number?}     highvolamend          (Ex: 577500)
 * @property  {string}      is_ammend             (Ex: '1' From BE)
 * @property  {string}      is_amend              (Alias from is_ammend)
 * @property  {string}      is_cancel             (Ex: '1')
 * @property  {boolean}     is_forcesell          (Ex: false)
 * @property  {OrderPeriod} period                (Ex: false)
 *
 */

/**
 * @typedef   {object}  OrderListMTResult
 *
 * @property  {number}          count                 (Ex: 22)
 * @property  {string?}         next
 * @property  {string?}         previous              (Ex: null)
 * @property  {OrderMt[]}       results
 */

/**
 * @typedef   {object}  OrderListMtResponse
 *
 * @property  {object}                data
 * @property  {string}                data.err_code      (Ex: "EC0000000")
 * @property  {string}                data.err_message   (Ex: "APPROVED/OK")
 * @property  {OrderListMTResult}     data.result
 *
 * @property  {number}                status            (Ex: 200)
 * @property  {string}                statusText        (Ex: '')
 */

/**
 *
 * @param {string}            url
 * @param {MtOrderListParams} mtOrderListParam
 * @returns
 */
function callbackFetch(
  url,
  { pageSize, periodType, statusType, tickerCode, transactionType, upDownPrice }
) {
  return async ({ pageParam = 1 }) => {
    try {
      /**
       * @type {OrderListMtResponse}
       */
      const res = await fetcher.get(url, {
        params: {
          page: pageParam,
          ticker_code: tickerCode,
          transaction_type: transactionType,
          period_type: periodType,
          status_type: statusType,
          up_down_price: upDownPrice,
          page_size: pageSize,
        },
      });

      return mapListEnvelope(res.data, mapOrderListItem);
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * @param {MtOrderListParams} mtOrderListParams
 * @returns
 */
export default function getV2StockMtOrderlistfilter(mtOrderListParams = { pageSize: 15 }) {
  const url = getUrl();
  const cb = callbackFetch(url, mtOrderListParams);
  const key = [url, JSON.stringify(mtOrderListParams)];

  return { cb, key };
}
